import { PropsWithChildren } from 'react';

const DetailsPageBodyWrapper = ({ children }: PropsWithChildren) => {
  return (
    <div className='w-full h-full flex flex-col md:flex-row ~gap-4/8'>
      {children}
    </div>
  );
};

export default DetailsPageBodyWrapper;
